import * as React from "react";

export const CalendarTimeIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.5} fill="currentColor">
      <path d="M15.969 5.579c0-.931-.475-1.756-1.194-2.238a2.67 2.67 0 0 0-1.506-.462H12.6v1.644a.623.623 0 0 1-.625.625.627.627 0 0 1-.625-.625V2.879H5.869v1.644a.627.627 0 0 1-.625.625.623.623 0 0 1-.625-.625V2.879H3.95c-.744 0-1.419.3-1.906.794a2.67 2.67 0 0 0-.794 1.906v.412h14.719zM3.95 16.586h5.619a5.56 5.56 0 0 1-.75-2.794 5.595 5.595 0 0 1 7.15-5.375V7.242H1.25v6.65a2.7 2.7 0 0 0 2.7 2.694" />
      <path d="M5.87 2.492a.627.627 0 0 0-.626-.625.623.623 0 0 0-.625.625v.388h1.25zm6.73 0a.623.623 0 0 0-.625-.625.627.627 0 0 0-.625.625v.388h1.25zm1.806 6.958a4.34 4.34 0 1 0 .005 8.683 4.34 4.34 0 0 0-.005-8.684m1.231 4.968h-1.231a.627.627 0 0 1-.625-.625v-1.287c0-.344.281-.626.625-.626.35 0 .625.282.625.625v.663h.606c.344 0 .625.275.625.625a.627.627 0 0 1-.625.625" />
    </g>
  </svg>
);
